import { Component, OnInit } from '@angular/core';
import { AuthService } from 'libs/shared-services/src/lib/auth.service';
import { Router } from '@angular/router';
import { CurrentProductService } from 'libs/shared-services/src/lib/current-product.service';
import { Product } from 'libs/shared-models/src/lib/product-type';
import { environment } from 'apps/admin/src/environments/environment';

@Component({
  selector: 'login-admin-redirect',
  templateUrl: './login-admin-redirect.component.html',
  styleUrls: ['./login-admin-redirect.component.scss'],
})
export class LoginAdminRedirectComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private currentProductService: CurrentProductService
  ) {}

  public ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('dashboard');
    } else {
      this.currentProductService.setProduct(Product.ADMIN);
      window.location.href = environment.PRODUCT_URLS.ACCOUNT + '/login';
    }
  }
}
